export const PASSWORD_MIN_LENGTH = 8;

export enum EnvEnum {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
  ACCEPTANCE = 'acceptance',
  TEST = 'test',
}
